import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute, { DashboardsProtections } from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LabsATVLiftContainer from 'containers/labs/LabsATVLiftContainer';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';

const LabATVCrossChannel = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer entityId={parseInt(props.match.params.entityId, 10)} hideDatePicker />}>

        <DetermineLayerContainer
            {...props}
            layerTwo={LabsATVLiftContainer}
            layerThree={LabsATVLiftContainer}
        />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute(DashboardsProtections),
    PageTitle({ pageTitle: 'Labs - ATV Cross Channel Insights' }),
    PageView({
        page: 'Viewed Labs - ATV Cross Channel Insights',
        trackEntity: true,
    }),
    PageTheme({
        themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme },
    }),
    PageQuery({
        params: {},
        initialTruth: 'location',
    })
)(LabATVCrossChannel);



// WEBPACK FOOTER //
// ./src/components/pages/labs/LabATVLift.js